// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1rc3T","included":"included-1497l","popular":"popular-1MlFF","cheap":"cheap-3qtMv"};